(function () {
  const BADGE_OPTIONS = [
    'Best Price',
    'Best Value',
    'Best Deal',
    'Save More',
    'Top Value',
    'Deal',
    'Popular',
    '+ Savings',
    'Hot Deal'
  ];

  const SINGLE_TEXT = 'or buy just one';
  const BUTTON_PREFIX = 'Buy';

  function randomBadgeText() {
    return BADGE_OPTIONS[Math.floor(Math.random() * BADGE_OPTIONS.length)];
  }

  if (!document.getElementById('custom-pack-quick-add-styles')) {
    const style = document.createElement('style');
    style.id = 'custom-pack-quick-add-styles';
    style.textContent = `
      .pack-badge{
        display:inline-block;
        margin-left:8px;
        padding:3px 7px;
        border-radius:999px;
        background:#fff;
        color:#B5122B;
        font-size:10px;
        font-weight:700;
        line-height:1;
        text-transform:uppercase;
        vertical-align:middle;
        white-space:nowrap;
      }

      product-card form.js-product-form{
        display:flex;
        flex-direction:column;
      }

      .buy-single-link{
        display:block;
        width:100%;
        height:18px;
        margin-top:8px;
        background:none;
        border:0;
        padding:0;
        text-align:center;
        text-decoration:underline;
        cursor:pointer;
        color:inherit;
        font-size:13px;
        line-height:18px;
        opacity:.85;
      }

      .buy-single-link:hover{
        opacity:1;
      }

      product-card form.js-product-form:not([data-pack-qty])::after{
        content:"";
        display:block;
        height:18px;
        margin-top:8px;
      }
    `;
    document.head.appendChild(style);
  }

  function getPackQty(card) {
    const tags = card.getAttribute('data-product-tags') || '';
    const match = tags.match(/(?:^|,)\s*(\d+)pack\s*(?:,|$)/i);
    return match ? Number(match[1]) : 1;
  }

  function createHiddenQuantity(form) {
    let quantityInput = form.querySelector('input[name="quantity"]');

    if (!quantityInput) {
      quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      form.appendChild(quantityInput);
    }

    return quantityInput;
  }

  function isAlreadyInCart(form) {
    const productForm = form.closest('product-form');
    return productForm && productForm.getAttribute('data-show-quantity-selector') === 'true';
  }

  function removeSingleLink(form) {
    const link = form.querySelector('.buy-single-link');
    if (link) link.remove();
  }

  function applyPackButtons() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (card.dataset.packApplied === 'true') return;

      const form = card.querySelector('form.js-product-form');
      if (!form) return;

      const packQty = getPackQty(card);
      if (!packQty || packQty <= 1) return;

      card.dataset.packApplied = 'true';
      form.dataset.packQty = String(packQty);

      const button = form.querySelector('[name="add"]');
      const text = form.querySelector('.quick-add-btn-text');
      const hidden = form.querySelector('.quick-add-btn-icon .visually-hidden');

      const label = `${BUTTON_PREFIX} ${packQty}-Pack`;
      const badge = randomBadgeText();

      if (text) {
        text.innerHTML = `${label} <span class="pack-badge">${badge}</span>`;
      }

      if (hidden) {
        hidden.textContent = label;
      }

      if (button) {
        button.dataset.addToCartText = label;
      }

      const quantityInput = createHiddenQuantity(form);
      quantityInput.value = String(packQty);

      if (isAlreadyInCart(form)) {
        removeSingleLink(form);
        return;
      }

      const singleLink = document.createElement('button');
      singleLink.type = 'button';
      singleLink.className = 'buy-single-link';
      singleLink.textContent = SINGLE_TEXT;

      form.appendChild(singleLink);

      singleLink.addEventListener('click', function () {
        form.dataset.packQty = '1';

        const quantityInput = createHiddenQuantity(form);
        quantityInput.value = '1';

        singleLink.remove();

        if (button) button.click();
      });
    });
  }
function getAddedFromLabel() {
  const path = window.location.pathname;

  if (path === '/') return 'Home Page';
  if (path.includes('/collections/')) return 'Collection Page';
  if (path.includes('/products/')) return 'Product Page';
  if (path.includes('/search')) return 'Search Page';
  if (path.includes('/pages/')) return 'Custom Page';

  return 'Other Page';
}

function setLineItemProperty(form, name, value) {
  let input = form.querySelector('input[name="properties[' + name + ']"]');

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    form.appendChild(input);
  }

  input.value = value;
}

function setAddToCartTracking(form) {
  setLineItemProperty(form, '_Added from', getAddedFromLabel());
  setLineItemProperty(form, '_Added path', window.location.pathname);
  setLineItemProperty(form, '_Added URL', window.location.href);
}
  document.addEventListener('submit', function (event) {
    const form = event.target;

    if (!form.classList || !form.classList.contains('js-product-form')) return;

    setAddToCartTracking(form);

    const qty = Number(form.dataset.packQty || 1);
    if (!qty || qty <= 1) return;

    if (isAlreadyInCart(form)) return;

    const quantityInput = createHiddenQuantity(form);
    quantityInput.value = String(qty);
  }, true);

  document.addEventListener('on:line-item:change', function (event) {
    const variantId = event.detail && event.detail.variantId;
    if (!variantId) return;

    document.querySelectorAll('form.js-product-form').forEach(function (form) {
      const productForm = form.closest('product-form');
      if (!productForm) return;

      if (String(productForm.dataset.variantId) === String(variantId)) {
        removeSingleLink(form);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPackButtons);
  } else {
    applyPackButtons();
  }
})();